import { useEffect, useState } from "react";
import { MakeApiCall } from "../apis";

export default function useTaxInputCreditRecoverable(userData) {
  const [isRecoverable, setIsRecoverable] = useState(false);

  useEffect(() => {
    if (!userData?.token) {
      setIsRecoverable(false);
      return undefined;
    }

    let cancelled = false;

    MakeApiCall("advanced-settings", "get", null, true, {}, userData.token).then((response) => {
      if (!cancelled && response?.status) {
        setIsRecoverable(!!response?.data?.is_tax_input_credit_recoverable);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [userData?.token]);

  return isRecoverable;
}
